import { ReactNode, useEffect, useState } from 'react';

import loadingImage from '@/assets/images/logo/ddm_loading.gif';
import sorryPuddingImage from '@/assets/images/character/pudding_sorry.gif';
import busyPuddingImage from '@/assets/images/character/pudding_busy.gif';
import cryDogImage from '@/assets/images/character/dog_cry.gif';

export interface ScreenOperatorProps {
    image?: string;
    message?: string;
    absolute?: boolean;
    screenBody?: ReactNode;
    status?: 404 | 403 | 500 | 'loading';
}

const ScreenOperator = ({
    message,
    absolute,
    screenBody,
    status,
    image,
    ...props
}: ScreenOperatorProps & Record<string, any>) => {
    const [defaultSet, setDefaultSet] = useState({
        // image: helloCowImage,
        image: loadingImage,
        message: '',
    });

    useEffect(() => {
        switch (status) {
            case 404:
                setDefaultSet({
                    image: busyPuddingImage,
                    message: '해당 정보를 찾을 수 없습니다.',
                });
                break;
            case 403:
                setDefaultSet({
                    image: sorryPuddingImage,
                    message: '해당 정보에 접근할 자격이 없습니다.',
                });
                break;
            case 500:
                setDefaultSet({
                    image: cryDogImage,
                    message: '알 수 없는 오류가 발생했습니다.',
                });
                break;
        }
        console.log(status, defaultSet);
    }, [status]);

    return (
        <div
            style={{
                position: absolute ? 'absolute' : 'fixed',
                inset: 0,
                backgroundColor: 'rgba( 255, 255, 255, 1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999,
            }}
        >
            {props.children || screenBody || (
                <div>
                    <div
                        className="flex flex-col items-center justify-center"
                        style={{
                            maxWidth: 250,
                            padding: 20,
                        }}
                    >
                        <img
                            src={defaultSet.image || image}
                            alt=""
                            style={{
                                // maxWidth: '40%',
                                maxWidth: '120px',
                                borderRadius: '50%',
                            }}
                        />
                        <div
                            className="text-center mt-4"
                            style={{
                                wordBreak: 'keep-all',
                                wordWrap: 'break-word',
                                color: '#666',
                            }}
                        >
                            {message || defaultSet.message}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ScreenOperator;
